export enum TargetedAssortmentEnum {
  A_MA_MANIERE = 'a-ma-maniere',
  ATMOS = 'atmos',
  BURNA_BOY = 'burna-boy',
  DAM_TO_DAM = 'dam-to-dam',
  DSG = 'dsg',
  DSM = 'dsm',
  EREWHON = 'erewhon',
  FKA_TWIGS = 'fka-twigs',
  FLEET_FEET = 'fleet-feet',
  FOOT_LOCKER = 'foot-locker',
  FREE_PEOPLE = 'free-people',
  HAKONE_EKIDEN = 'hakone-ekiden',
  HOUSE_OF_SPORTS = 'house-of-sports',
  HYPE_DC = 'hype-dc',
  JD = 'jd',
  KITH = 'kith',
  LN1 = 'ln1',
  LOEWE = 'loewe',
  NORDSTROM = 'nordstrom',
  PAF = 'paf',
  SHOE_PALACE = 'shoe-palace',
  SKY_HIGH_FARM = 'sky-high-farm',
  SNEAKER_PROGRAM = 'sneaker-program',
  WHITAKER_GROUP = 'whitaker-group',
  ZENDAYA = 'zendaya',
}
